// extracted by mini-css-extract-plugin
module.exports = {"body":"SearchPlayers_body__1lyKf","title":"SearchPlayers_title__3yuad","brand":"SearchPlayers_brand__24fdO","description":"SearchPlayers_description__1zN-Z"};